import { Controller } from 'stimulus';

/**
 * Auto-submits the vote form when the page is loaded with `?vote=1` in the
 * URL (post-login redirect flow).
 *
 * Note: The vote button is kept disabled until JS loads by the generic
 * `turbo-ready` controller — this controller only handles the auto-vote logic.
 *
 * @example
 *   <turbo-frame data-controller="contests--auto-vote">
 *     <form data-contests--auto-vote-target="form" ...>
 *       <button disabled data-controller="turbo-ready" ...></button>
 *     </form>
 *   </turbo-frame>
 */
export default class extends Controller {
  static targets = ['form'];

  connect() {
    if (!this.#shouldAutoVote()) {
      return;
    }

    this.#cleanUpUrl();
    this.formTarget.requestSubmit();
  }

  #shouldAutoVote() {
    return new URLSearchParams(window.location.search).get('vote') === '1';
  }

  #cleanUpUrl() {
    const url = new URL(window.location.href);
    url.searchParams.delete('vote');
    window.history.replaceState({}, '', url);
  }
}
